<template>
  <div>
    <div class="items">
      <div class="span9">
        <div class="content" id="securityBox">
          <div class="content">
            <div class="module emp_alert pr">
              <div style="padding: 15px;display: flex;flex-direction: column;" v-if="itemLists.length" >
                <template v-for="(data,index) in itemLists" >
                  <ul class="item-title">{{data.title}}</ul>
                  <ul class="item-box">
                    <li class="item-row wid100 margin15" v-if="data.type==2">
                      <div class="wid40"><span class="name"></span></div>
                      <div class="wid33" :class="{'wid30':data.showUnit=='10020002'}">
                        <span class="value">个人</span>
                      </div>
                      <div class="wid33" v-if="data.showUnit!=='10020002'">
                        <span class="value">单位</span>
                      </div>
                    </li>
                    <li class="item-row " :class="{'wid50':data.type==1&&data.showType!=0,'mr15':data.type==1&&data.showType!=0,'wid100':data.showType==0||data.type==2,'margin15':data.showType==0||data.type==2}" v-for="(item1,i) in data.itemList" :key="i">
                      <div class="wid40" v-if="data.type==2"><span class="name">{{item1.name}}</span></div>
                      <div v-else><span class="name">{{item1.name}}</span></div>
                      <div :class="{'wid33':data.type==2,'wid30':data.showUnit=='10020002'}">
                        <span class="value" v-if="data.type==2">{{item1.selfMoney}}</span>
                        <span class="value" v-else>{{item1.money}}</span>
                      </div>
                      <div class="wid33" v-if="data.type==2&&data.showUnit!=='10020002'">
                        <span class="value">{{item1.unitMoney}}</span>
                      </div>
                    </li>
                  </ul>
                </template>
              </div>
               <div v-else>
                 <noData style="margin-top: 200px;" msg="暂无数据"></noData>
               </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import noData from "@/wage-components/bsp-noData/bsp-noData.vue"
  import draggable from "vuedraggable";

  export default {
    name: "paySettingItem",
    components: {draggable, noData},
    created() {
       console.log("------------------啦啦啦------------")
      console.log(this.itemLists);

    },
    props: {
      detailId: {
        type: String,
        default: ''
      },
      empId: {
        type: String,
        default: ''
      },
      batchId: {
        type: String,
        default: ''
      },
      itemLists:{
        type:Array,
        default:[]
      }
    },
    data() {
      return {
        show: true,
        dialogStatus: 'add', // 弹框状态
        dialogFormVisible: false,
        listForm: {},
        dialogheaderVisible: false,
        dialogItemVisible: false,

      };
    },
    methods: {

    }
  };
</script>

<style scoped lang='scss'>
  .itemBox {
    padding: 0 10px;
  }

  .itemLists {
    margin-top: 20px;
  }

  .itemList {
    margin-bottom: 20px;
    padding: 0 20px;
    cursor: move;
  }

  .itemListBox {
    background-color: #f3f3f3;
    display: flex;
    justify-content: space-between;
    line-height: 30px;
    padding: 0 20px;
    border-radius: 2px;
  }

  .itemList p {
    color: #666666;
    font-size: 12px;
  }

  .itemTitle p.drag {
    flex: 1;
    cursor: move;
  }

  .itemList p + p {
    color: #000000;
    font-size: 14px;
  }

  .itemTitle {
    background: #FFEDBE;
    display: flex;
    justify-content: space-between;
    padding: 0 15px;
  }

  .itemTitle p {
    color: #000000;
    font-size: 14px;
    line-height: 30px;
  }

  .itemTitle p + p {
    color: #AA5401;
    font-size: 12px;
    cursor: pointer;
  }

  .itemTitle p .icon {
    margin-right: 5px;
  }

  .pr {
    position: relative;
  }

  .module {
    box-shadow: 0 0 3px rgba(0, 0, 0, .1);
    border-color: #e9e9e9;
    margin-bottom: 20px;
    background-color: #fff;
    border-radius: 4px;
    -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, .05);
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-bottom-color: #bbb;
    -moz-box-shadow: 0 0 1px rgba(0, 0, 0, 0.2);
  }

  .module-head {
    color: #767676;
    background-color: #f6f6f6;
    border-color: #e9e9e9;
    padding: 10px 15px;
    border-bottom: 1px solid transparent;
    border-top-right-radius: 3px;
    border-top-left-radius: 3px;
  }

  .titleBox {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .layui-inline {
    position: relative;
    display: inline-block;
    *display: inline;
    *zoom: 1;
  }

  .item-title {
    padding: 5px 10px;
    background: rgba(253, 242, 184, 1);
    font-weight: bold;
  }

  .item-row .value {
    color: #000;
  }

  .item-row .name {
    color: #666;
  }

  .item-row div {
    padding: 0px 10px;
  }

  .item-box {
    margin-bottom: 15px;
    margin-top: 15px;
    display: flex;
    flex-wrap: wrap;
  }
  .item-box:last-of-type{
    margin-bottom: 0;
  }

  .wid100 {
    width: 100%;
  }

  .wid50 {
    width: 49.15%;
  }

  .item-row {
    display: inline-flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    padding: 5px 0px;
    background: #f5f5f5;
    float: left;
    line-height: 20px;
    margin-bottom: 15px;
    margin-right: 9px;
  }
  .mr15{
    margin-right: 15px;
  }
  .item-row:last-of-type{
    margin-bottom: 15px;
  }
  .item-row:nth-child(even){
    margin-right: 0px;
  }
  .margin15{
    margin-right: 0!important;
  }

  .emp_search_box, .emp_search_box:hover, .layui-progress-bar {
     background: rgba(253, 242, 184, 1);
  }
  .wid40{
    width: 40%;
  }
  .wid33{
    width: 30%;
  }
  .wid30{
    width: 30%;
    text-align: right;
  }

</style>
